export const TASK_ROOT_ROUTE = 'task-overview';
export const HOME_ROUTE = TASK_ROOT_ROUTE;
export const CLEANING_ROUTE = 'cleaning-overview';
export const MEMO_ROUTE = 'memo-overview';
export const STACKS_ROUTE = 'stacks-overview';
export const ASSIGNED_DOSSIER_TASK_ROUTE = 'my-dossiers-overview';
export const INVOICING_TASK_ROUTE = 'task-invoicing';
export const BOOKING_OVERVIEW_ROUTE = 'booking-overview';
export const BOOKING_DETAIL_ROUTE = 'booking-detail';
export const STATUS_BOARD_ROUTE = 'status-board';
export const DOSSIER_DETAIL_ROUTE = 'dossier-detail';
export const JOB_PARENT_ROUTE = 'dossier-jobs-parent';
export const JOB_MASTER_ROUTE = 'dossier-jobs';
export const JOB_DETAIL_ROUTE = 'dossier-job-detail';
export const DMS_COMMENTS_ROUTE = 'dossier-jobs-dms';
export const CHECK_IN_PARENT_ROUTE = 'dossier-check-in-parent';
export const CHECK_IN_MASTER_ROUTE = 'dossier-check-in';
